import { render, staticRenderFns } from "./dropoff-rate.vue?vue&type=template&id=5acd78fc&scoped=true&"
import script from "./dropoff-rate.vue?vue&type=script&lang=js&"
export * from "./dropoff-rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acd78fc",
  null
  
)

export default component.exports